// 微信日历预约点为
export const WeixinPlaces = [
    { id: 1, name: "12：00（1条）", channel_id: 116 },
    { id: 2, name: "12：00（2条）", channel_id: 116 },
    { id: 3, name: "12：00（3条）", channel_id: 116 },
    { id: 4, name: "12：00（4条）", channel_id: 116 },
    { id: 5, name: "12：00（5条）", channel_id: 116 },
    { id: 6, name: "16：00（1条）", channel_id: 116 },
    { id: 7, name: "16：00（2条）", channel_id: 116 },
    { id: 8, name: "16：00（3条）", channel_id: 116 },
    { id: 9, name: "16：00（4条）", channel_id: 116 },
    { id: 10, name: "16：00（5条）", channel_id: 116 },
    { id: 11, name: "20：00（1条）", channel_id: 116 },
    { id: 12, name: "20：00（2条）", channel_id: 116 },
    { id: 13, name: "20：00（3条）", channel_id: 116 },
    { id: 14, name: "20：00（4条）", channel_id: 116 },
    { id: 15, name: "20：00（5条）", channel_id: 116 },
    { id: 100, name: "备选列表", channel_id: 116 },
]
